export const system_actions_routes = [
  {
    path: "/systemactions",
    component: () => import("../Main.vue"),
    name: "Configurações"
  }
];

export default {};
